export default "__VITE_ASSET__xJEWU80x__"